module.exports = __webpack_public_path__ + "static/img/15.930cb21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/15.png
// module id = 1nhs
// module chunks = 0